import $ from "jquery";
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import PostLoginGetApi from '../../../../components/Api/PostLoginGetApi';
import PostLoginPostApi from '../../../../components/Api/PostLoginPostApi';

import { useContext } from 'react';
import OtpSpace from "../../../../assets/icons/otp-space.png";
import UserBasicInfoQRContext from '../../../../components/Context/UserBasicInfoQRContext';
import Popup from '../../../../components/Popup';
import init from '../../AccessControl/Check';
import { ReactComponent as CloseBtn } from './../../../../assets/icons/close.svg';

const AllVoucher = () => {
    const pageName = "Voucher List View";
    const isAccess = init(pageName);

    const companyInfo = useContext(UserBasicInfoQRContext);
    const [redeemCounter, setRedeemCounter] = useState(0);
    const [voucherList, setVoucherList] = useState([]);
    const [otp, setOtp] = useState(new Array(6).fill(""));


    const [reqParam, setReqParam] = useState({
        page: 1,
    });


    const [apiData, setApiData] = useState({});

    // Voucher List
    useEffect(() => {
        PostLoginGetApi("voucher/redeem/list", reqParam, 2).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setApiData(responseData["data"]);
                    setVoucherList(responseData["data"]);
                }
            }
        }).catch((error) => {
            console.log(error);
        });

    }, [redeemCounter, companyInfo, reqParam]);

    const [isOpen, setIsOpen] = useState(false);

    const [voucherCode, setVoucherCode] = useState("");
    const [voucherInfo, setVoucherInfo] = useState([]);

    const submitForm = () => {

        if (voucherCode === "") {
            toast.error("Please enter voucher code.");
            return;
        }

        // API CALL
        PostLoginPostApi("voucher/redeem/check", JSON.stringify({ voucher_code: voucherCode }), 1).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData?.code === 200) {
                    if (responseData?.data?.length === 0) {
                        toast.error(responseData?.messages ?? "OTP issue");
                        return;
                    }


                    setOtp(new Array(6).fill(""));
                    setIsOpen(true);
                    setVoucherInfo(responseData?.data);

                    setTimeout(()=> $(".redeem_voucher_otp").eq(0).focus(), 500);


                    toast.success(responseData?.messages);

                    return;
                }

                toast.error(responseData.messages);
                return;
            }

            toast.error("No active voucher code found.");
            return;

        }).catch((error) => {
            console.log(error);
        });

        return;
    }


    useEffect(() => {
        $(".SubmitBtn").attr("disabled", true);
        if (voucherCode.toString().length === 8) {
            $(".SubmitBtn").attr("disabled", false);
        }
    }, [voucherCode]);


    const redeemVoucher = (code, otp) => {
        $("#redeem-button").html("Please wait...");
        $("#redeem-button").attr("disabled", true);

        setOtp(new Array(6).fill(""));
        // Redeem Voucher
        if (otp.length === 6) {
            PostLoginPostApi("voucher/redeem/execute", JSON.stringify({ voucher_code: code, otp: otp }), 1).then((responseJSON) => {
                let response = JSON.stringify(responseJSON);
                response = JSON.parse(response);

                if (response["status"] === 1) {
                    let responseData = JSON.stringify(response["data"]);
                    responseData = JSON.parse(responseData);


                    if (responseData["code"] === 200) {

                        toast.success("Voucher redeemed successfully.");

                        setRedeemCounter((prevCounter) => {
                            return prevCounter + 1;
                        });

                        setIsOpen(false);
                        setVoucherInfo([]);
                        setVoucherCode("");
                        return;
                    }

                    $("#redeem-button").html("Redeem Voucher");
                    $("#redeem-button").attr("disabled", false);


                    toast.error(responseData["messages"].toString());
                    return;
                }


                toast.error("A problem occur while redeem the voucher. Please try again.");

            }).catch((error) => {
                console.log(error);
                toast.error("A problem occur. Please try again.");
            });
        }



    }

    // For Otp Input
    function handleChange(element, index) {

        if (isNaN(element.value)) {
            return false;
        }

        setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);

        if (element.value !== "" && element.parentNode.nextElementSibling) {
            element.parentNode.nextElementSibling.querySelector('input').focus();
        }

        if (element.value === "" && element.parentNode.previousSibling) {
            element.parentNode.previousSibling.querySelector('input').focus();
        }
    }

    const pagination = (next = 1) => {
        if (next === 1) {
            setReqParam({ ...reqParam, page: reqParam.page + 1 });
            return;
        }

        if (reqParam.page > 1) {
            setReqParam({ ...reqParam, page: reqParam.page - 1 });
            return;
        }

        setReqParam({ ...reqParam, page: 1 });
        return;
    }

    if (isAccess === false) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }


    return (
        <div className='custom-container w-full font-montserrat flex -mt-4'>
            <div className="custom-container-left float-left custom-scroll-auto min-w-[80%] w-full pr-3 pb-20 text-justify" style={{ boxShadow: "3px 0 0px 0px rgb(0 0 0 / 1%)" }}>

                <div className='w-full pt-4 flex'>
                    <h6 className="w-1/2 text-xl pt-4 font-medium">Here’s your vouchers at a glance</h6>
                    <div className="w-1/2 font-medium pb-0 float-right">
                        <div className="flex form-body items-center  bg-white float-right">
                            <div className="relative w-[300px] bg-white px-2 rounded-md border border-gray-300">
                                <input type="text" id="voucherCodeInput" name="voucherCodeInput" autoComplete='off' className="block pl-0.5 rounded-t-lg px-2.5 pb-2 pt-6 w-full text-[15px] text-[#222222] bg-white dark:bg-gray-700 border-0 border-b-2 border-white appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-[#34A853] peer" minLength={8} maxLength={8} placeholder=" " value={voucherCode}
                                    onChange={(e) => setVoucherCode(e.target.value.toString().toUpperCase())} required />

                                <label htmlFor="voucherCodeInput" className="absolute text-base pt-1 text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-3 scale-75 top-3.5 z-10 origin-[0] left-2.5 peer-focus:text-[#34A853] peer-focus:dark:text-[#34A853] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3">Enter Voucher Code</label>
                            </div>

                            <button type="button" onClick={submitForm} className="SubmitBtn text-white bg-primary px-10 py-4 ml-3 rounded cursor-pointer hover:bg-brand-dark disabled:bg-gray-300">
                                Validate Voucher
                            </button>
                        </div>
                    </div>
                </div>


                {/* Data Table */}

                <div className="flex flex-col w-full pt-5">
                    <div className='-m-1.5 pt-0'>
                        <div className='p-1.5 min-w-full inline-block align-middle'>
                            <div className='border rounded-lg shadow'>
                                <table className='min-w-full divide-y divide-gray-200 custom-table-hover'>
                                    <thead className='bg-neutral-100'>
                                        <tr className='text-left '>
                                            <th scope="col" className="px-6 py-3 border-r-2 text-center w-10">#</th>
                                            <th scope="col" className="px-6 pr-2 py-3">Brand & Category</th>
                                            <th scope="col" className="px-6 pr-2 py-3">Offer Title</th>
                                            <th scope="col" className="py-2 text-center">Face value</th>
                                            <th scope="col" className="px-2 text-center">Sell price</th>
                                            <th scope="col" className="px-2 text-center">Selling Date</th>
                                            <th scope="col" className="px-2 text-center" title="Redeem Days">R. Days</th>
                                            <th scope="col" className="px-2 text-center">Total</th>
                                            <th scope="col" className="px-2 text-center" title="Remaining">Unsold</th>
                                            <th scope="col" className="px-2 text-center" title="Purchased">Sold</th>
                                            <th scope="col" className="px-2 text-center" title="Redeemed">Used</th>
                                            <th scope="col" className="px-2 text-center" title="Remaining">Unused</th>
                                            {/* <th className='rounded-tr-lg text-center max-w-[100px]'>Action</th> */}
                                        </tr>
                                    </thead>

                                    <tbody className='divide-y divide-gray-200 text-base'>
                                        {(voucherList.length > 0) ? voucherList.map((val, index) =>
                                            <tr key={index}>
                                                <td className='px-6 py-4 border-r-2 text-center'><strong>{index + 1}</strong></td>
                                                <td className='px-6 pr-2 py-2 border-r-2'>
                                                    {val?.brand_name}
                                                    <br/>{val?.category_name}
                                                </td>
                                                <td className='px-6 pr-2 py-4 border-r-2'>{val?.offer_name}</td>
                                                <td className='py-4 border-r-2 text-center'>{val?.amount}</td>
                                                <td className='py-4 border-r-2 text-center'>{val?.purchase_price}</td>
                                                <td className='py-2 border-r-2 text-center'>
                                                            {moment(val?.validity_start_date, "YYYY-MM-DD").format("DD-MMM-YYYY")}
                                                            <br/>{moment(val?.validity_end_date, "YYYY-MM-DD").format("DD-MMM-YYYY")}
                                                </td>
                                                <td className='py-2 border-r-2 text-center'>
                                                    {(val?.redeem_type === 'days') ?
                                                        <>{val?.redeem_period}</>
                                                        :
                                                        <>
                                                            {moment(val?.redeem_start_date, "YYYY-MM-DD").format("DD-MMM-YYYY")}
                                                            <br/>{moment(val?.redeem_end_date, "YYYY-MM-DD").format("DD-MMM-YYYY")}
                                                        </>
                                                    }
                                                </td>
                                                <td className='py-4 border-r-2 text-center'>{val?.total_cards ?? 0}</td>
                                                <td className='py-4 border-r-2 text-center'>{val?.remaining}</td>
                                                <td className='py-4 border-r-2 text-center'>{val?.purchased + val?.redeemed}</td>
                                                <td className='py-4 border-r-2 text-center'>{val?.redeemed}</td>
                                                <td className='py-4 text-center'>{val?.unused}</td>
                                            </tr>
                                        ) :
                                            <tr>
                                                <td colSpan={12} className="px-6 py-4 text-center">No voucher available.</td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>

                            {(apiData?.meta?.from) !== undefined &&
                                <>
                                    <p className='float-left mt-7'>
                                        {`Showing ${apiData?.meta?.from * 1} - ${apiData?.meta?.to * 1} out of ${apiData?.meta?.total * 1}`}
                                    </p>


                                    {(apiData?.links?.next !== null && apiData?.links?.next !== "") &&
                                        <button onClick={() => pagination(1)} className="custom-btn float-right mt-5">
                                            Next Page&nbsp;&nbsp;&rarr;
                                        </button>
                                    }

                                    {(apiData?.links?.prev !== null && apiData?.links?.prev !== "") &&
                                        <button onClick={() => pagination(0)} className="custom-btn float-right mt-5 mr-2">
                                            &larr;&nbsp;&nbsp;Previous Page
                                        </button>
                                    }
                                </>
                            }
                        </div>
                    </div>
                </div>




                {/* MODAL WINDOW */}
                <div>
                    {(isOpen === true && voucherInfo?.length === 1) && <Popup content={
                        <div className="p-5 font-medium">

                            <div className="flex justify-between">
                                <h3 className="text-lg">Voucher Details</h3>
                                <CloseBtn onClick={() => setIsOpen(false)} className="cursor-pointer" />
                            </div>

                            <hr className="bg-dark-white my-2" />

                            <table id="voucher-details-table" className="custom-details-table w-full mt-0 mb-5">
                                <tbody>
                                    <tr>
                                        <td className="font-semibold text-base">Voucher Code</td>
                                        <td className="px-5 text-base">{voucherInfo[0]?.payloads}</td>
                                    </tr>
                                    <tr>
                                        <td className="font-semibold text-base">Brand</td>
                                        <td className="px-5 text-base">{voucherInfo[0]?.brand?.name}</td>
                                    </tr>
                                    <tr>
                                        <td className="font-semibold text-base">Offer</td>
                                        <td className="px-5 text-base">{voucherInfo[0]?.offer?.name}</td>
                                    </tr>
                                    <tr>
                                        <td className="font-semibold text-base">Expire</td>
                                        <td className="px-5 text-base">{voucherInfo[0]?.offer?.validity_end_date}</td>
                                    </tr>
                                    <tr>
                                        <td className="font-semibold text-base">Face Value</td>
                                        <td className="px-5 text-base">{voucherInfo[0]?.offer?.amount}</td>
                                    </tr>
                                    <tr>
                                        <td className="font-semibold text-base">Sell Price</td>
                                        <td className="px-5 text-base">{(voucherInfo[0]?.offer?.purchase_price === null) ? "-" : voucherInfo[0]?.offer?.purchase_price}</td>
                                    </tr>
                                    <tr>
                                        <td className="font-semibold text-base">Status</td>
                                        <td className="px-5 text-base">{(voucherInfo[0]?.status === 1) ? "Unused" : "Redeemed"}</td>
                                    </tr>

                                    {(voucherInfo[0]?.status === 2 && voucherInfo[0]?.updated_at) && 
                                        <tr>
                                            <td className="font-semibold text-base">Redeemed Date</td>
                                            <td className="px-5 text-base">{moment(voucherInfo[0]?.updated_at).format("DD MMM, YYYY hh:mm A")}</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>

                            {(voucherInfo[0]?.status === 1 && voucherInfo[0]?.offer?.redeem_status === 1) &&
                                <>
                                    <h1 className='text-center mb-5 font-semibold text-lg'>OTP</h1>
                                    <div className="flex items-center space-x-2 w-full container mb-5">
                                        {otp.map((data, index) => {
                                            return (
                                                <span className='flex justify-center items-center' key={index}>
                                                    <input
                                                        type="text"
                                                        name="otp[]"
                                                        maxLength="1"
                                                        key={index}
                                                        value={data}
                                                        className="w-[60px] h-[60px] border border-solid border-[#EEEEEE] rounded-lg text-center redeem_voucher_otp"
                                                        onChange={(e) => {
                                                            handleChange(e.target, index);
                                                        }}
                                                        onFocus={(e) => e.target.select()}

                                                    />
                                                    {((index + 1) % 2 === 0 && index < (otp.length - 1)) && (<img alt="OTP Space" src={OtpSpace} className="h-[2px] w-[9px] ml-[8px] mr-0"></img>)}
                                                </span>

                                            );
                                        })}
                                    </div>
                                </>
                            }

                            {( (voucherInfo[0]?.status === 1 && voucherInfo[0]?.offer?.redeem_status === 1) &&
                                <button onClick={() => redeemVoucher(voucherInfo[0]?.payloads, otp.join(''))} type="button" id="redeem-button" className="text-white bg-primary py-3 text-lg rounded cursor-pointer w-full hover:bg-brand-dark disabled:bg-gray-400 disabled:cursor-wait">
                                    Redeem Voucher
                                </button>
                            )}


                            {(voucherInfo[0]?.offer?.redeem_status === 0) && 
                                <button type="button" disabled={true} className="text-white bg-gray-500 py-3 text-lg rounded cursor-pointer w-full disabled:bg-gray-400">
                                    Voucher redeem period is over
                                </button>
                            }

                        </div>}
                    />}
                </div>
            </div>
        </div >
    );
};

export default AllVoucher;